import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertService } from '../../views/shared/alert/alert.service';
import { AppService } from '../../app.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly apiUrl = 'api/Auth';
  private readonly tokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(private readonly http: HttpClient,
    private service: AppService, private readonly router: Router, public alertService: AlertService) { }

  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/login`, { email, password }).pipe(
      tap(response => {
        // Store the access token in localStorage
        localStorage.setItem('access_token', response.access_token);
        this.tokenSubject.next(response.access_token);
        this.startSessionTimeOut()
      })
    );
  }

  private readonly apiUrl2 = 'api/auth/impersonate'
  loginForAM(id: any): Observable<any> {
    return this.http.post<any>(this.apiUrl2, id).pipe(
      tap(response => {
        // Store the access token in localStorage
        localStorage.setItem('access_token', response.access_token);
        this.tokenSubject.next(response.access_token);
        this.startSessionTimeOut()
      })
    );
  }
  private readonly apiUrl3 = 'api/Auth/revertToAccountManager'

  backToAM(id: any): Observable<any> {
    return this.service.get<any>(this.apiUrl3 + '/' + `${id}`).pipe(
      tap(response => {
        // Store the access token in localStorage
        localStorage.setItem('access_token', response.access_token);
        this.tokenSubject.next(response.access_token);
        this.startSessionTimeOut()
      })
    );
  }
  startSessionTimeOut() {
    setTimeout(() => {
      this.logout();
    }, 3600000);
  }


  logout() {
    this.router.navigate(['login'])
    this.alertService.warning('session expired')
    localStorage.removeItem('authToken');
    localStorage.removeItem('userID');
    localStorage.removeItem('userName');
    localStorage.removeItem('access_token');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('appUserID');
    localStorage.removeItem('customerID');
    localStorage.removeItem('caseID');
    this.tokenSubject.next(null);
  }

  getToken(): string | null {
    return localStorage.getItem('authToken');
  }

  isLoggedIn(): boolean {
    const token = this.getToken() || localStorage.getItem('authToken');
    if (token == "undefined") {
      return false
    } else {

      return !!token;
    }
  }
}
